import { useQuery } from '@tanstack/react-query';
import { TIME_FORMAT_WITH_UTC } from 'config/constants';
import { get } from 'utils/axios';
import { GenericQueryOptions } from 'queries/sensors/types';
import { RISK_PLOT_VIEW } from 'config/endpoints';
import { RiskScoreDataParams, RiskScoreGraphicData, RiskScoreQueryProps } from './contract';

export const useRiskScoreQuery = (
  { modelName, startDate, endDate, window }: RiskScoreQueryProps,
  queryOptions?: GenericQueryOptions<RiskScoreGraphicData>,
  signal?: AbortSignal,
) => {
  return useQuery(
    [
      'RISK_SCORE',
      'MODEL_PAGE',
      startDate?.format('YYYY-MM-DDTHH:mm'),
      endDate?.format('YYYY-MM-DDTHH:mm'),
      window,
      modelName,
    ],

    get<RiskScoreGraphicData, RiskScoreDataParams>(RISK_PLOT_VIEW(modelName), {
      start_date: startDate?.utc().format(TIME_FORMAT_WITH_UTC),
      end_date: endDate?.utc().format(TIME_FORMAT_WITH_UTC),
      window: window ?? '',
      signal,
    }),

    { ...queryOptions, retry: false },
  );
};
